import OSS from 'ali-oss'
import React, { useState, Fragment, useEffect } from 'react'
import { Upload, Icon, Modal, message, Button } from 'antd'
import ImgCrop from 'antd-img-crop'
import 'antd/es/modal/style'
import 'antd/es/slider/style'
import styles from './index.less'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

const ImgUploader = props => {
  const { OSSConfig, changeSrc, files, maxSize, disabled } = props
  const [show, changeShow] = useState(false)
  const [previewImage, setPreviewImage] = useState('')
  const [previewVisible, setPreviewVisible] = useState(false)

  const [fileList, setFileList] = useState([])
  const client = new OSS(OSSConfig)

  const uploadPath = (path, file) => {
    return `${path}/${file.name.split('.')[0]}-${file.uid}.${file.type.split('/')[1]}`
  }


  const UploadToOss = (self, path, file) => {
    const url = uploadPath(path, file)
    return new Promise((resolve, reject) => {
      client
        .multipartUpload(url, file)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  const handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }
    setPreviewImage(file.url)
    setPreviewVisible(true)
  }

  const beforeUpload = file => {
    changeShow(true)
    let reader = new FileReader()
    const folder = ''

    if (maxSize) {
      const isLtxM = file.size / 1024 / 1024 <= maxSize
      if (!isLtxM) {
        message.error(`请上传小于${maxSize}M的图片!`)
        changeShow(false)
        return isLtxM
      }
    }

    reader.readAsDataURL(file)
    reader.onloadend = () => {
      UploadToOss(this, folder, file)
        .then(data => {
          changeShow(false)
          return data
        })
        .then(data => {
          let src = data.res.requestUrls[0]

          src = src.indexOf('?') > -1 ? src.substr(0, src.indexOf('?')) : src

          changeSrc(src)
        })
    }

    return false
  }

  const uploadProps = {
    beforeUpload: beforeUpload,
    disabled: disabled,
    fileList: files,
    accept: 'image/*',
    listType: 'picture-card',
    showUploadList: {
      showPreviewIcon: true,
      showRemoveIcon: false,
    },
    onPreview(file) {
      handlePreview(file)
    }
  }

  const uploadButton = (
    <div style={{ backgroundColor: '#fff' }}>
      {/* <Icon type={show ? 'loading' : 'plus'} /> */}
      {/* <div className="ant-upload-text">上传图片附件</div> */}
      <Button loading={show} disabled={disabled}>上传图片附件</Button>
      <span style={{ color: 'orange' }}>仅支持手机拍的照片尺寸（4:3）</span>
    </div>
  )

  // useEffect(() => {
  // 	if(files && files.length) {
  // 		setFileList(props.files)
  // 	}
  // }, [])

  return (
    <Fragment className={styles.imageCutUpload}>
      {/* <ImgCrop rotationSlider aspect={3 / 4}> */}
      <Upload className={styles.uploadBtn} {...uploadProps}>{uploadButton}</Upload>
      {/* </ImgCrop> */}
      <Modal visible={previewVisible} footer={null} onCancel={() => setPreviewVisible(false)}>
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </Fragment>
  )
}

export default ImgUploader
